define.alias("shared/components/shared/wizards/device-setup", "media/components/shared/wizards/device-setup");